// extracted by mini-css-extract-plugin
export default {"container":"style_container__HYBbX","title":"style_title__bwAc5","desctiption":"style_desctiption__wdpRd","btn":"style_btn__KTl6W"};